"use client";

import { cn } from "@/lib/utils";

interface Category {
  id: string;
  name: string;
  color?: string;
  itemCount: number;
}

interface CategoryTabsProps {
  categories: Category[];
  selectedId: string | null;
  onSelect: (id: string | null) => void;
}

export function CategoryTabs({ categories, selectedId, onSelect }: CategoryTabsProps) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-surface-border-2">
      <button
        onClick={() => onSelect(null)}
        className={cn(
          "shrink-0 rounded-xl px-5 py-2.5 text-sm font-medium transition-all duration-200 touch-target",
          "active:scale-95",
          selectedId === null
            ? "bg-white text-black shadow-lg shadow-white/10"
            : "bg-white/5 text-text-muted hover:bg-white/10 hover:text-white",
        )}
      >
        All
      </button>
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => onSelect(category.id)}
          className={cn(
            "shrink-0 rounded-xl px-5 py-2.5 text-sm font-medium transition-all duration-200 inline-flex items-center gap-2 touch-target",
            "active:scale-95",
            selectedId === category.id
              ? "bg-white text-black shadow-lg shadow-white/10"
              : "bg-white/5 text-text-muted hover:bg-white/10 hover:text-white",
          )}
        >
          {category.color && (
            <span
              className="h-2.5 w-2.5 rounded-full shrink-0"
              style={{ backgroundColor: category.color }}
            />
          )}
          {category.name}
        </button>
      ))}
    </div>
  );
}
